import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { EditorialMarquee, LogoWall } from "./components/site/Marquee";
import { Testimonials } from "./components/site/Testimonials";
import { Results } from "./components/site/Results";
import { Problems } from "./components/site/Problems";
import { Process } from "./components/site/Process";
import { Founder } from "./components/site/Founder";
import { Pricing } from "./components/site/Pricing";
import { Qualify } from "./components/site/Qualify";
import { Faq } from "./components/site/Faq";
import { FinalCta, Footer, WhatsAppFab } from "./components/site/Closing";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="grain min-h-screen bg-paper font-body text-ink antialiased">
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <LogoWall />
        <Results />
        <Testimonials />
        <Problems />
        <Process />
        <Founder />
        <Pricing />
        <Qualify />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}

export default App;
